import Api from '.';
import { endpoints } from './endpoints';

export default class Dashboard extends Api {

    GETPMSDITDashboard(data) {
        let url = this.buildUrl(endpoints.dashboard.GETPMSDITDashboard)
        return this.fetch(url, "GET", JSON.stringify(data)).then(response => response)
    }
    GETPMSDITActiveYear(data) {
        let url = this.buildUrl(endpoints.dashboard.GETPMSDITActiveYear)
        return this.fetch(url, "GET", JSON.stringify(data)).then(response => response)
    }
    GETPMSDITCommissionTrendYTD(data) {
        let url = this.buildUrl(endpoints.dashboard.GETPMSDITCommissionTrendYTD)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GETPMSDITSalesOverViewMTD(data) {
        let url = this.buildUrl(endpoints.dashboard.GETPMSDITSalesOverViewMTD)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GETPMSDITAUMTrendYTD(data) {
        let url = this.buildUrl(endpoints.dashboard.GETPMSDITAUMTrendYTD)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GETPMSDITInvestorTrendYTD(data) {
        let url = this.buildUrl(endpoints.dashboard.GETPMSDITInvestorTrendYTD)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GETPMSDITSalesOverViewYTD(data) {
        let url = this.buildUrl(endpoints.dashboard.GETPMSDITSalesOverViewYTD)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

}